module.exports = __webpack_public_path__ + "img/img4-1.c35f94d8.png";